import { connect } from "react-redux";
import { MicroplateReadout1 as Component } from "./MicroplateReadout1";
import { State, OwnProps, MapStateToProps } from "../types";

function mapStateToProps(
  state: State,
  ownProps: OwnProps
): OwnProps & MapStateToProps {
  return {
    ...ownProps,
    wellsColors: state["microplate"]?.wellsColors || {},
  };
}
export const MicroplateReadout1Redux = connect(mapStateToProps)(Component);
